<div role="main" class="app-content-area">
    <div>
        <ng-content></ng-content>
        <router-outlet></router-outlet>
    </div>
</div>
